import { ShipperTypeahead } from '../inputs/ShipperTypeahead'
import type { FilterComponentProps } from './types'

export const SelectFilter = ({
  name,
  options,
  setQueryString,
  value,
}: FilterComponentProps) => {
  const selectOptions = options ?? []
  const selectedOption = selectOptions.find(opt => opt.value === value) ?? null

  return (
    <div className="mt-2">
      <ShipperTypeahead
        name={name}
        options={selectOptions}
        value={selectedOption}
        onSelect={option => {
          setQueryString(qs => {
            const params = new URLSearchParams(qs)
            if (option?.value) {
              params.set(name, option.value)
            } else {
              params.delete(name)
            }
            return params.toString()
          })
        }}
        getOptionLabel={o => o.text}
        getOptionValue={o => o.value}
        isClearable
        placeholder="Select or type to search..."
      />
    </div>
  )
}
